/**
 * Shimeji Browser Extension
 *
 * Adds a container for its desktop-pet animations to every page.
 * Observed on version 2.0.5.
 */
import { probeSelector } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'gohjpllcolmccldfdggmamodembldgpc';
export const shimeji: ExtensionDefinition = {
  id: ID,
  name: 'Shimeji Browser Extension',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 1_000_000,
  signals: [
    { id: 'dom-work-area', kind: 'dom',
      description: 'Look for #shimeji-workArea — the animation container injected into every page.',
      weight: 1, run: () => probeSelector('#shimeji-workArea', { timeoutMs: 1500 }) },
  ],
};
